import type { SwiperContainer } from 'swiper/element'
import type { Swiper } from 'swiper'
import { REM } from '../../../assets/constants/fontsize'
import { getCookie, setCookie } from '../../../assets/frontend/js/utils/cookie'
import { TODAY_END } from '../../../assets/constants/datetime'
import { DisplayController } from '../../../assets/frontend/js/utils/dom'

const newsticker = document.querySelector<HTMLDivElement>('.newsticker')
const slider = document.querySelector<SwiperContainer>('.newsticker-slider')
const closeButton = newsticker?.querySelector<HTMLButtonElement>('.close')
const toastElement = document.querySelector<HTMLDivElement>('.newsticker-toast')

var isInitialized = false

const params = {
  injectStyles: [
    `.swiper-button-prev svg,
    .swiper-button-next svg
    { display: none; }`
  ],
  slidesPerView: 1,
  speed: 1000,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
    pauseOnFocus: true
  },
  loop: true,
  pagination: {
    clickable: true
  },
  navigation: false,
  spaceBetween: 1 * REM,
  on: {
    slideChange(this: Swiper & { hostEl: HTMLElement }) {
      const slide = this.slides[this.activeIndex ?? 0] ?? null
      if (!slide) {
        return
      }
      const textColor = window.getComputedStyle(slide as HTMLElement)?.color
      newsticker?.style.setProperty('--navigation-color', textColor)
      this.hostEl.style.setProperty('--swiper-navigation-color', textColor)

      if (isInitialized) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'icf_newsticker_slide_change',
          newsticker_slide_index: this.realIndex,
          newsticker_slide_title: slide.textContent?.trim() || ''
        })
      }
    }
  }
}

const desktopParams = {
  navigation: true,
  pagination: false
}

type NewsEntry = {
  icon: string
  color: string
  content: string
}

async function fetchNewsEntries(endpoint: string) {
  const response = await fetch(endpoint)
  if (!response.ok) {
    throw new Error(`Newsticker request failed (${response.status})`)
  }
  const data = await response.json()
  return Array.isArray(data) ? (data as NewsEntry[]) : []
}

function createSlide(newsEntry: NewsEntry) {
  const slide = document.createElement('swiper-slide')
  slide.className = `text-bg-${newsEntry.color}`

  const icon = document.createElement('i')
  icon.className = `icon icon--fixed-width ${newsEntry.icon}`
  icon.setAttribute('aria-hidden', 'true')

  const text = document.createElement('div')
  text.className = 'text'
  // sanitized server-side (wp_kses)
  text.innerHTML = newsEntry.content

  slide.append(icon, text, document.createElement('div'))
  return slide
}

function initNewsticker(slider: SwiperContainer, toastElement: HTMLDivElement) {
  Object.assign(slider, params)
  slider.initialize()
  const resizeObserver = new ResizeObserver(() => {
    if (window.innerWidth > 768) {
      Object.assign(slider, desktopParams)
    } else {
      Object.assign(slider, params)
    }
  })
  resizeObserver.observe(slider)
  const toast = new DisplayController(toastElement)
  setTimeout(() => {
    toast.show()
  }, 500)
  closeButton?.addEventListener('click', () => {
    toast.hide()
    setCookie('newsticker-dismissed', 'true', TODAY_END.toDate())
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'icf_newsticker_close',
    })
    isInitialized = false
  })
  isInitialized = true
}

const endpoint = newsticker?.dataset.endpoint
if (slider && toastElement && endpoint && !getCookie('newsticker-dismissed')) {
  fetchNewsEntries(endpoint)
    .then((newsEntries) => {
      if (newsEntries.length === 0) {
        return
      }
      slider.append(...newsEntries.map(createSlide))
      initNewsticker(slider, toastElement)
    })
    .catch((error) => {
      console.error(error)
    })
}
